class ProductAdjustments extends HTMLElement {
  constructor() {
    super();
    this.optionValue = this.querySelector(".js-option-value");
    this.fieldset = this.querySelector(".js-adjustment-fieldset");
    this.input = this.querySelector(".js-wrist-size");
    this.listeners();
  }

  listeners() {
    this.fieldset.addEventListener("change", this.handleChange.bind(this));
  }

  handleChange() {
    const value = this.querySelector("input:checked").value;
    this.updateOptionValue(value);
    this.updateInput(value);
  }

  updateOptionValue(value) {
    this.optionValue.innerHTML = value;
  }

  updateInput(value) {
    this.input.value = value;
  }
}

customElements.define("product-adjustments", ProductAdjustments);
